/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IOrderScheduler contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IOrderSchedulerConfig extends Msdyn365.IModuleConfig {
    className?: string;
    minDate?: number;
    maxMonths?: number;
    invalidDays?: IExcludeDaysData[];
}

export interface IOrderSchedulerResources {
    saveButtonText: string;
    orderSchedulerLabel: string;
    orderScheduleSetOrEditText: string;
}

export interface IOrderSchedulerProps<T> extends Msdyn365.IModule<T> {
    resources: IOrderSchedulerResources;
    config: IOrderSchedulerConfig;
}

export const enum ExcludeDaysDay {
    sunday = 'sunday',
    monday = 'monday',
    tuesday = 'tuesday',
    wednesday = 'wednesday',
    thursday = 'thursday',
    friday = 'friday',
    saturday = 'saturday'
}

export interface IExcludeDaysData {
    day?: ExcludeDaysDay;
}
